module.exports = __webpack_public_path__ + "static/media/img-administrator.c70b5a3f.png";